import { useCollection, orderBy, limit } from '../../lib/hooks.js';
import { formatTimestamp } from '../../lib/format.js';

interface AuditRow {
  id: string;
  userId?: string;
  action?: string;
  docId?: string;
  billId?: string;
  targetUserId?: string;
  timestamp?: { seconds: number };
  detail?: Record<string, unknown>;
}

export function AuditLog() {
  const { docs, loading } = useCollection<AuditRow>('audit', [
    orderBy('timestamp', 'desc'),
    limit(500),
  ]);

  return (
    <div className="mx-auto w-full max-w-6xl space-y-4 px-6 py-6">
      <header>
        <h1 className="text-2xl font-bold tracking-tight">Audit log</h1>
        <p className="text-sm text-stone-500">
          Append-only. Most recent 500 events.
        </p>
      </header>

      <div className="card overflow-hidden">
        {loading ? (
          <div className="px-6 py-10 text-center text-sm text-stone-400">Loading…</div>
        ) : docs.length === 0 ? (
          <div className="px-6 py-10 text-center text-sm text-stone-400">
            No audit entries yet.
          </div>
        ) : (
          <table className="w-full text-sm">
            <thead className="border-b border-stone-200 bg-stone-50 text-left text-xs uppercase tracking-wider text-stone-500">
              <tr>
                <th className="px-4 py-2">When</th>
                <th className="px-4 py-2">Actor</th>
                <th className="px-4 py-2">Action</th>
                <th className="px-4 py-2">Target</th>
                <th className="px-4 py-2">Detail</th>
              </tr>
            </thead>
            <tbody>
              {docs.map((a) => (
                <tr key={a.id} className="border-b border-stone-100 text-xs">
                  <td className="px-4 py-2 text-stone-500">
                    {formatTimestamp(a.timestamp)}
                  </td>
                  <td className="px-4 py-2 font-mono text-stone-600">
                    {a.userId?.slice(0, 8)}
                  </td>
                  <td className="px-4 py-2">
                    <span className="chip">{a.action}</span>
                  </td>
                  <td className="px-4 py-2 font-mono text-stone-600">
                    {a.docId?.slice(0, 14) ??
                      a.billId?.slice(0, 14) ??
                      a.targetUserId?.slice(0, 14) ??
                      '—'}
                  </td>
                  <td className="px-4 py-2 text-stone-500">
                    {a.detail ? JSON.stringify(a.detail).slice(0, 80) : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
